import React from 'react';
import styled from 'styled-components';
import { Field } from 'react-final-form';
import FormLabel from '@omilia/form-label';

type Props = {
  items: { label: string; value: string }[];
  disabled: boolean;
};

const SRadioFormGroup = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-top: 15px;
`;

const SRadioFormGroupItems = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 10px;

  & > label {
    margin-right: 32px;
  }
`;

const RadioFieldGroup = ({ items, disabled }: Props) => (
  <SRadioFormGroup>
    <FormLabel htmlFor="separator" variant="default">
      Select file separator
    </FormLabel>
    <SRadioFormGroupItems>
      {items.map(({ label, value }) => (
        <Field
          key={label}
          name="separator"
          render={({ input, children }) => (
            <label htmlFor={label}>
              <input disabled={disabled} id={label} type="radio" {...input} />
              {children}
            </label>
          )}
          type="radio"
          value={value}
        >
          {label}
        </Field>
      ))}
    </SRadioFormGroupItems>
  </SRadioFormGroup>
);

export default RadioFieldGroup;
